import { useEffect, useState } from "react";
import { VENUE_URL, VENUE_NAME } from "@/lib/tickets";

const Hero = () => {
  const [scrolled, setScrolled] = useState(0);
  useEffect(() => {
    const onScroll = () => setScrolled(Math.min(1, window.scrollY / 600));
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToImmersion = () => {
    const el = document.getElementById("immersion");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative h-[100svh] w-full overflow-hidden bg-black text-[color:var(--bone)]"
    >
      <div
        className="absolute inset-0"
        style={{ transform: `translate3d(0, ${scrolled * 40}px, 0)` }}
      >
        <img
          src="/artworks/universal-gaze.jpg"
          alt="Universal Gaze by Nick Fraser"
          className="h-full w-full object-cover slow-zoom"
          style={{ opacity: 0.72 }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.15) 40%, rgba(0,0,0,0.55) 100%)",
          }}
        />
      </div>

      {/* Top meta */}
      <div className="absolute top-0 left-0 right-0 z-10 px-6 md:px-12 pt-8 md:pt-10 flex items-center justify-between">
        <span className="hairline" data-testid="hero-brand">
          Nick Fraser
        </span>
        <span className="hairline opacity-70" data-testid="hero-year">
          MMXXVI
        </span>
      </div>

      {/* Bottom anchored title */}
      <div className="absolute bottom-0 left-0 right-0 z-10 px-6 md:px-12 pb-16 md:pb-20">
        <div className="max-w-[1400px] mx-auto">
          <p className="hairline mb-6 md:mb-8" data-testid="hero-location">
            <a
              href={VENUE_URL}
              target="_blank"
              rel="noreferrer"
              className="link-quiet"
              data-testid="hero-venue-link"
            >
              {VENUE_NAME}
            </a>{" "}
            · London
          </p>
          <h1
            className="font-serif italic leading-[0.9] tracking-tight text-[18vw] md:text-[11vw] lg:text-[9rem]"
            data-testid="hero-title"
          >
            Chapter II
          </h1>
          <p
            className="font-serif italic text-2xl md:text-3xl mt-4 md:mt-6 opacity-80"
            data-testid="hero-subtitle"
          >
            A continuation.
          </p>
        </div>
      </div>

      {/* Enter prompt */}
      <button
        type="button"
        onClick={scrollToImmersion}
        data-testid="hero-enter-button"
        className="group absolute bottom-8 right-6 md:right-12 z-10 flex flex-col items-center gap-3 text-[color:var(--bone)]"
        aria-label="Enter the exhibition"
      >
        <span className="hairline opacity-80 group-hover:opacity-100 transition-opacity duration-700">
          Enter
        </span>
        <span className="enter-line" />
      </button>
    </section>
  );
};

export default Hero;